import { BaseAPI } from '../BaseAPI'

export const baseAddress: string =
  process.env.REACT_APP_API_BASE_URL || 'https://localhost:44367'

export type HttpGetMetaData<T> = {
  page?: number
  pageSize?: number
  search?: string
  orderBy?: keyof T
  totalCount?: number
  orderDirection?: 'desc' | 'asc'
}
export abstract class InternalAPI extends BaseAPI {
  baseAddress: string = baseAddress

  /**
   *
   * @param relativePath - relative path to the API /api/...
   */
  constructor(relativePath?: string) {
    super()
    this.relativePath = relativePath ?? '/'
  }
}
